import styled from 'styled-components'
import PropTypes from 'prop-types'
import React from 'react'

const TagBase = styled.div`
  height: 20px;
  border-radius: 9.5px;
  padding: 0 10px;
  display: flex;
  font-size: 0.9em;
  justify-content: center;
  align-items: center;
  background: ${({ background = '#f4f4f4' }) => background};

  ${({ color = '#db5959' }) => `color: ${color};`}
`

const FillRateTag = ({ children, ...props }) => {
  return (
    <TagBase {...props}>
      {children}
    </TagBase>
  )
}
FillRateTag.propTypes = {
  children: PropTypes.any,
  tagType: PropTypes.any,
  color: PropTypes.string
}

export default FillRateTag
